import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { Visibility, VisibilityEvents } from "common/components/base/stackable";
import { Placement } from "common/components/tooltip/types";
import { hasSlot } from "common/util/dom";
import { SvgIconEl } from "../svg-icon";
import { Direction } from "./types";
import { OtherTogglePanelSource } from "./constants";
export function template() {
  const { isCollapsed, isResizing, hasOpenDropdown } = this.state;
  let collapseTooltipText = `${isCollapsed ? `Show` : `Collapse`} ${this.attr(`panel-name`)}`;
  const collapseShortcutLabel = this.collapseShortcutLabel;
  if (collapseShortcutLabel) {
    collapseTooltipText += ` ${collapseShortcutLabel}`;
  }
  const showContentFooter = hasSlot(this, `footer`) || this.attr(`extra-actions`).length || this.attr(`show-collapse-button`);
  return /* @__PURE__ */ jsx("div", {
    sel: ".wrapper",
    class: {
      "is-collapsed": isCollapsed,
      "is-resizing": isResizing,
      "has-open-dropdown": hasOpenDropdown,
      "resize-top": this.attr(`resize-direction`) === Direction.Top,
      "resize-right": this.attr(`resize-direction`) === Direction.Right
    },
    attrs: { elref: `wrapper` },
    on: {
      [VisibilityEvents[Visibility.Open]]: () => this.update({ hasOpenDropdown: true }),
      [VisibilityEvents[Visibility.Closed]]: (ev) => this.update({ hasOpenDropdown: ev.detail.stackSize !== 1 })
    }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".content-wrapper",
    attrs: { elref: `contentWrapper` }
  }, /* @__PURE__ */ jsx("slot", null)), showContentFooter && /* @__PURE__ */ jsx("div", {
    sel: ".content-footer"
  }, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `footer` }
  }), !isCollapsed && this.attr(`extra-actions`).map(({ value, icon, label }) => /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      elref: `extraButton_${value}`,
      theme: ButtonTheme.Tertiary,
      icon,
      tooltip: {
        text: label,
        placement: Placement.Top
      }
    },
    sel: ".side-button.extra-button",
    on: { click: () => this.helpers.handleExtraActionClick({ value, icon, label }) }
  })), this.attr(`show-collapse-button`) && /* @__PURE__ */ jsx(ButtonEl, {
    attrs: {
      elref: `collapseButton`,
      theme: ButtonTheme.Tertiary,
      tooltip: {
        text: collapseTooltipText,
        placement: this.helpers.getSideButtonTooltipDirection()
      }
    },
    on: { click: () => this.toggleCollapsed({ source: OtherTogglePanelSource.Button }) }
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: this.helpers.getCollapseButtonIconDirection() }
  }))), !isCollapsed && !this.attr(`fixed-size`) && /* @__PURE__ */ jsx("div", {
    sel: ".resize-handle",
    on: {
      mousedown: (ev) => this.startResizing(ev)
    },
    class: {
      "resize-right": this.attr(`resize-direction`) === Direction.Right,
      "resize-top": this.attr(`resize-direction`) === Direction.Top
    },
    attrs: { elref: `resizeHandle` }
  }));
}
